import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { alunos_situacao } from "../../services/api";

const Alunos_situacao = (props) => {

    const [data2, setData2] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await alunos_situacao(data_inicio, data_fim);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const transpose = (matrix) => {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    };

    let chartDataAS = [];

    let tpcp = 0;
    let tpd = 0;
    let trcp = 0;
    let trd = 0;
    let tcpg = 0;


    if (typeof data2 !== 'undefined') {
        chartDataAS = data2.map((item, index) => {
            const row = [item.nome];
            row.push(item.pcp || 0);
            tpcp = tpcp + parseInt(item.pcp);
            row.push(item.pd || 0);
            tpd = tpd + parseInt(item.pd);
            row.push(item.rcp || 0);
            trcp = trcp + parseInt(item.rcp);
            row.push(item.rd || 0);
            trd = trd + parseInt(item.rd);
            row.push(item.cpg || 0);
            tcpg = tcpg + parseInt(item.cpg);
            row.push(parseInt(item.pcp) + parseInt(item.pd) + parseInt(item.rcp) + parseInt(item.rd) + parseInt(item.cpg))
            return row;
        });
    };

    chartDataAS.sort()
    chartDataAS.unshift(['Unidade', 'P - Pgt P', 'P- Doc. P', 'R - Pgt P', 'R - Doc. P', 'R - Conf P', 'TOTAL']);
    chartDataAS.push(['TOTAL', tpcp.toString(), tpd.toString(), trcp.toString(), trd.toString(), tcpg.toString(), (tpcp + tpd + trcp + trd + tcpg)]);

    const chartDataAST = transpose(chartDataAS);

    if (chartDataAS.length <= 1) {
        return <div className="media">Carregando...</div>;
    }

    return (
        <div className="media">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartDataAS}
            />
        </div>
    );
};
export default Alunos_situacao;
